import { useContext } from 'react';
import { AddProjectContext } from '../../../../../TemporaryConmonents/AddProject/Context/AddProjectContext';

export const useProjectTeamForemenRow = () => {
    const { foremans } = useContext(AddProjectContext);

    return { foremans };
};
